<template>
  <div class="container-fluid">
    <div class="page-title">
      <i class="fa-light fa-users"></i>
      <h1>{{ $t("COMMON.USERS") }}</h1>
    </div>
    <div class="page-wrapper">
      <div slot="header" class="page-wrapper-header">
        <div class="row">
          <div class="col-6">
            <h3 class="mb-0">{{ $t("USERS.USERS_LIST") }}</h3>
          </div>
          <div class="col-6 text-right">
            <base-button
              class="elite-button add"
              icon
              size="sm"
              @click="openUserCreateModal"
              v-if="$currentUserCan($permissions.PERM_CREATE_USERS)"
            >
              <span class="btn-inner--icon">
                <i class="far fa-plus-circle"></i>
              </span>
              <span class="btn-inner--text">{{ $t("USERS.ADD_USER") }}</span>
            </base-button>
            <!--<notification-subscription
              v-if="$currentUserCan($permissions.PERM_VIEW_USERS)"
              :objectType="'users'"
              :events="{
                CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
              }"
            />-->
          </div>
        </div>
      </div>

      <user-list-table
        @onViewUser="openUserViewModal"
        @onEditUser="openUserEditModal"
        @onDeleteUser="deleteUser"
        @onActivateUser="onActivateUser"
        @onDeactivateUser="onDeactivateUser"
        :key="renderKey * 100"
      />

      <div
        v-if="isViewUserModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isViewUserModalOpened ? 'show' : 'hide']"
        :key="renderKey * 200"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'USER'"
          @onCloseModal="closeUserModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("USERS.VIEW") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <notification-subscription
                v-if="openUser"
                :objectType="'users'"
                :objectId="openUser.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
              <base-dropdown
                title-classes="btn dropdown-button"
                menu-on-right
                :has-toggle="false"
              >
                <template slot="title">
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <button class="edit" @click="openUserEditModal(openUser)">
                  <i class="fal fa-edit"></i>
                  <span>{{ $t("COMMON.EDIT") }}</span>
                </button>
                <button class="delete" @click="deleteUser(openUser)">
                  <i class="fal fa-trash-alt"></i>
                  <span>{{ $t("COMMON.DELETE") }}</span>
                </button>
              </base-dropdown>
              <button class="close" @click="closeUserModal(true)">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <view-user-page
              v-if="openUser"
              :userId="openUser.id"
              @onEditUser="openUserEditModal"
              @onActivateUser="onActivateUser"
              @onDeactivateUser="onDeactivateUser"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isEditUserModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isEditUserModalOpened ? 'show' : 'hide']"
        :key="renderKey * 300"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'USER'"
          @onCloseModal="closeUserModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("USERS.EDIT_USER") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <button class="close" @click="openUserViewModal(openUser)">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <edit-user-page
              v-if="openUser"
              :userId="openUser.id"
              @onViewUser="openUserViewModal"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isAddUserModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isAddUserModalOpened ? 'show' : 'hide']"
        :key="renderKey * 400"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'USER'"
          @onCloseModal="closeUserModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("USERS.ADD_USER") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <button class="close" @click="closeUserModal(true)">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <add-user-page @onViewUser="openUserViewModal" />
          </div>
        </div>
      </div>
    </div>

    <inspection-confirmation-modal
      :confirm-action="activateUser"
      :confirm-button-text="$t('COMMON.YES_ACTIVATE')"
      :loading="loading"
      :message="$t('USERS.ACTIVATE_THIS_USER')"
      :open.sync="showActivateUserModal"
      modal-classes="modal-secondary validate"
    />

    <inspection-confirmation-modal
      :confirm-action="deactivateUser"
      :confirm-button-text="$t('COMMON.YES_DEACTIVATE')"
      :loading="loading"
      :message="$t('USERS.DEACTIVATE_THIS_USER')"
      :open.sync="showDeactivateUserModal"
      modal-classes="modal-secondary validate"
    />
  </div>
</template>
<script>
import { cloneDeep } from "lodash";
import swal from "sweetalert2";
import { Button } from "element-ui";
import requestErrorMixin from "@/mixins/request-error-mixin";
import {
  QUERY_ACTIONS_VIEW,
  QUERY_ACTIONS_EDIT,
  QUERY_ACTIONS_ADD,
} from "@/constants/common";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import UserListTable from "./partials/UserListTable.vue";
import EditUserPage from "./components/EditUserComponent.vue";
import AddUserPage from "./components/AddUserComponent.vue";
import ViewUserPage from "./components/ViewUserComponent.vue";
import InspectionConfirmationModal from "@/components/InspectionConfirmationModal.vue";

export default {
  layout: "DashboardLayout",

  components: {
    UserListTable,
    NotificationSubscription,
    EditUserPage,
    AddUserPage,
    ViewUserPage,
    InspectionConfirmationModal,
    [Button.name]: Button,
  },

  mixins: [requestErrorMixin],

  computed: {},

  watch: {},

  data() {
    const userId = this.$route.query.id;
    const action = this.$route.query.action;
    let isViewUserModalOpened = false;
    let isEditUserModalOpened = false;
    let isAddUserModalOpened = false;
    let openUser = null;
    if (userId && action) {
      if (action === QUERY_ACTIONS_VIEW) {
        isViewUserModalOpened = true;
      } else if (action === QUERY_ACTIONS_EDIT) {
        isEditUserModalOpened = true;
      }
      openUser = { id: userId };
    } else if (action === QUERY_ACTIONS_ADD) {
      isAddUserModalOpened = true;
    }
    return {
      isViewUserModalOpened: isViewUserModalOpened,
      isEditUserModalOpened: isEditUserModalOpened,
      isAddUserModalOpened: isAddUserModalOpened,
      openUser: openUser,
      loading: false,
      renderKey: 1,
      showActivateUserModal: false,
      showDeactivateUserModal: false,
    };
  },

  methods: {
    openUserCreateModal() {
      this.closeUserModal();
      this.isAddUserModalOpened = true;

      this.$router.replace({
        name: "List Users",
        query: { action: QUERY_ACTIONS_ADD },
      });
    },
    openUserViewModal(user, reRender = false) {
      this.closeUserModal();
      this.openUser = user;
      this.isViewUserModalOpened = true;
      if (reRender) {
        this.renderKey++;
      }

      this.$router.replace({
        name: "List Users",
        query: { id: this.openUser.id, action: QUERY_ACTIONS_VIEW },
      });
    },
    openUserEditModal(user) {
      this.closeUserModal();
      this.openUser = user;
      this.isEditUserModalOpened = true;

      this.$router.replace({
        name: "List Users",
        query: { id: this.openUser.id, action: QUERY_ACTIONS_EDIT },
      });
    },
    closeUserModal(goBack = false, grid = false) {
      if (goBack && this.$store.getters["routes/previousPathRoute"]) {
        if (grid) {
          this.$store.dispatch("routes/goBackToPreviousGrid");
        } else {
          this.$store.dispatch("routes/goToPreviousPath");
        }
        return;
      }
      this.isAddUserModalOpened = false;
      this.isViewUserModalOpened = false;
      this.isEditUserModalOpened = false;
      this.openUser = null;

      if (
        this.$route.name !== "List Users" ||
        JSON.stringify(this.$route.query) !== JSON.stringify({})
      ) {
        this.$router
          .replace({
            name: "List Users",
            query: {},
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              throw err;
            }
          });
      }
    },

    async deleteUser(user) {
      const confirmation = await swal.fire({
        title: this.$t("USERS.DELETE_THIS_USER"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      let me = await this.$store.getters["profile/me"];

      if (user.id === me.id) {
        swal.fire({
          title: this.$t("USERS.CANNOT_SELF_DELETE"),
          buttonsStyling: false,
          showCancelButton: false,
          confirmButtonText: this.$t("COMMON.YES"),
          confirmButtonClass: "btn btn-primary",
        });
        return;
      }

      try {
        if (confirmation.isConfirmed) {
          await this.$store.dispatch("users/destroy", user.id);
          this.renderKey++;
          this.closeUserModal();
          this.$notify({
            type: "success",
            timeout: 3000,
            message: this.$t("USERS.USER_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    onActivateUser(user) {
      this.openUser = cloneDeep(user);

      this.$nextTick(function () {
        this.showActivateUserModal = true;
      });
    },

    onDeactivateUser(user) {
      this.openUser = cloneDeep(user);

      this.$nextTick(function () {
        this.showDeactivateUserModal = true;
      });
    },

    async activateUser() {
      swal.showLoading();
      this.loading = true;
      this.formErrors = null;

      try {
        await this.$store.dispatch("users/activate", this.openUser.id);
        this.showActivateUserModal = false;
        // this.refreshTable();
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("USERS.USER_ACTIVATED"),
        });
        this.renderKey++;

        this.$nextTick(function () {
          swal.close();
        });
        // this.openUser = null;
      } catch (error) {
        swal.close();
        await this.showRequestError(error, false);
        this.formErrors = error.response?.data?.errors;
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      } finally {
        this.loading = false;
      }
    },

    async deactivateUser() {
      swal.showLoading();
      this.loading = true;
      this.formErrors = null;

      try {
        await this.$store.dispatch("users/deactivate", this.openUser.id);
        this.showDeactivateUserModal = false;
        // this.refreshTable();
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("USERS.USER_DEACTIVATED"),
        });
        this.renderKey++;
        this.$nextTick(function () {
          swal.close();
        });
      } catch (error) {
        swal.close();
        await this.showRequestError(error, false);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
